import { OptionsType } from '@europrocurement/flexy-components';

const useCharge = () => {
    const charges: OptionsType = [
        { value: 1, label: 'Très simple' },
        { value: 2, label: 'Simple' },
        { value: 3, label: 'Standard' },
        { value: 4, label: 'Complexe' },
        { value: 5, label: 'Très complexe' },
    ];

    const getChargeLabel = (chargeId: number): string | undefined =>
        charges.find((charge) => charge.value === chargeId)?.label;

    return { charges, getChargeLabel };
};

export default useCharge;
